import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { selectPath } from '../../../../layout/store/slice'
import { ButtonBack } from '../../../common/html/button/ButtonBack'
import { ROUTE_CAN_GO_TO_LIBRARY } from '../../../constant'
import style from '../index.module.scss'
import { getLoadingSavedPortfolio, selectTotal } from '../store/slice/slice'
import { getHeaderSavedPortfolio } from '../store/thunk'

export const Header = () => {
  const dispatch = useDispatch()

  const totalCount = useSelector(selectTotal)
  const isLoadingHeader = useSelector(
    getLoadingSavedPortfolio('headerSavedPortfolio'),
  )
  const prevPath = useSelector(selectPath('prevPath'))
  const isPrevPath = Object.values(ROUTE_CAN_GO_TO_LIBRARY).some(
    (item) => item === prevPath.split('/').at(-1),
  )

  useEffect(() => {
    dispatch(getHeaderSavedPortfolio())
  }, [])

  return (
    <div>
      <Element
        className={style.header}
        style={{
          borderColor: '#e5e5e8',
          opacity: isLoadingHeader ? 0 : 1,
        }}
      >
        <>
          <div className={`${style.title}`}>
            {isPrevPath && <ButtonBack />}
            <Element
              elementName="div"
              style={{ fontSize: 24, color: '#0553a5' }}
              className={style.textTitle}
            >
              <Translate value="library.main.SAVED_PORTFOLIO" />
            </Element>
          </div>
          <div className={style.total}>
            <Element
              className={style.totalItem}
              style={{ backgroundColor: '#eff3fa' }}
            >
              <Element elementName="p">
                <Translate value="library.savePortfolio.TOTAL_PORTFOLIO" />
              </Element>
              <Element
                elementName="span"
                style={{
                  fontSize: 16,
                  lineHeight: '24px',
                }}
              >
                {totalCount?.totalPortfolios || 0}
              </Element>
            </Element>
            <Element
              className={style.totalItem}
              style={{ backgroundColor: '#eff3fa' }}
            >
              <Element elementName="p">
                <Translate value="library.savePortfolio.TOTAL_COMPANIES" />
              </Element>
              <Element
                elementName="span"
                style={{
                  fontSize: 16,
                  lineHeight: '24px',
                }}
              >
                {totalCount.totalCompanies || 0}
              </Element>
            </Element>
          </div>
        </>
      </Element>
    </div>
  )
}
